import { lazy } from 'react';
import { Route, Routes } from 'react-router-dom';
import { demoPagesMenu, landingPagesMenu } from '../../menu';
import ContactPage from '../../pages/contact/ContactPage';
import HomePage from '../../pages/home/HomePage';
import PolicyPage from '../../pages/policy/PolicyPage';
import Login from '../../pages/presentation/auth/Login';
import PricingPage from '../../pages/pricing/PricingPage';
import contents from '../../routes/contentRoutes';

const PAGE_404 = lazy(() => import('../../pages/presentation/auth/Page404'));
const ContentRoutes = () => {
	return (
		<Routes>
			<Route
				key={landingPagesMenu.home.path}
				path={landingPagesMenu.home.path}
				element={<HomePage />}
			/>
			<Route
				key={landingPagesMenu.policy.path}
				path={landingPagesMenu.policy.path}
				element={<PolicyPage />}
			/>
			<Route
				key={landingPagesMenu.contact.path}
				path={landingPagesMenu.contact.path}
				element={<ContactPage />}
			/>
			<Route
				key={landingPagesMenu.pricing.path}
				path={landingPagesMenu.pricing.path}
				element={<PricingPage />}
			/>
			<Route
				key={demoPagesMenu.login.path}
				path={demoPagesMenu.login.path}
				element={<Login />}
			/>
			{contents.map((page) => (
				// eslint-disable-next-line react/jsx-props-no-spreading
				<Route key={page.path} {...page} />
			))}
			<Route path='*' element={<PAGE_404 />} />
		</Routes>
	);
};

export default ContentRoutes;
